import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import screenFull from 'screenfull';
import { useTranslation } from '@/utils/util';

const FullscreenToggle: React.FC = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const t = useTranslation();

  //切换全屏函数
  const toggleFullscreen = () => {
    if (screenFull.isEnabled) {
      screenFull.toggle();
    }
  };

  useEffect(() => {
    if (!screenFull.isEnabled) {
      return;
    }

    const handleFullscreenChange = () => {
      setIsFullscreen(screenFull.isFullscreen);
    };

    screenFull.on('change', handleFullscreenChange);

    // 清理事件
    return () => {
      screenFull.off('change', handleFullscreenChange);
      screenFull.exit();
    };
  }, []);

  return (
    <Tooltip
      key={isFullscreen ? 'exit' : 'enter'}
      title={
        isFullscreen
          ? t('component.exitFullscreen')
          : t('component.enterFullscreen')
      }
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          height: 26,
          padding: '0 8px',
        }}
        onClick={toggleFullscreen}
      >
        {isFullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
      </div>
    </Tooltip>
  );
};

export default FullscreenToggle;
